import { Location } from '@cobliteam/common-types';

import { Button, Popover, Tooltip, Typography } from '@cobliteam/ui/components';
import Icon from '@cobliteam/ui/icons';
import React from 'react';

interface CameraIdentifierProps {
  hasCta?: boolean;
  className?: string;
  customTooltipLabel?: string;
}

const CameraIdentifier = React.memo(({ hasCta = false, className, customTooltipLabel }: CameraIdentifierProps) => {
  const tooltipLabel = customTooltipLabel || 'Veículo equipado com Cobli Cam';

  const handleCtaClick = () => {
    window.open(Location.CAMERA_EVENTS, '_blank');
  };

  return (
    <Popover>
      <Popover.Trigger disabled={!hasCta} className={className}>
        <Tooltip content={tooltipLabel} position={hasCta ? 'bottom' : 'top'}>
          <Icon name='video' className='box-content rounded-full bg-gray-3 p-1' size='sm' />
        </Tooltip>
      </Popover.Trigger>
      <Popover.Content align='center' side='top' className='w-72 space-y-2' portal={false}>
        <Typography variant='description-title'>Veículo equipado com Cobli Cam</Typography>
        <Typography variant='body'>Para ver eventos capturados pela Cobli Cam, acesse a aba clicando no botão abaixo.</Typography>
        <Button variant='ghost' className='mx-auto' onClick={handleCtaClick}>
          Ver Cobli Cam
        </Button>
      </Popover.Content>
    </Popover>
  );
});

export default CameraIdentifier;
